import r from "./invoker.mjs";
var i = /* @__PURE__ */ r(1, "split");
export {
  i as default
};
